import styled from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import { white } from '../../styles/colors';
import media from '../../styles/media';

export const BannerContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  padding-top: 24px;
  padding-bottom: 13px;
  color: ${white};
  background-color: ${({ theme }) => theme.secondaryColor};
  border-radius: 3px;
`;

export const BannerContentTitle = styled.h3`
  ${fontSize(14)};
  font-weight: normal;

  ${media.desktop`
    ${fontSize(18)};
  `};
`;
